import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=ec908340&"
import script from "./Register.vue?vue&type=script&lang=ts&"
export * from "./Register.vue?vue&type=script&lang=ts&"
import style0 from "./Register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports